import './GiftCard.css'
import React from 'react';
import creative from '../../img/gift/creative-mob.png'

export default class GiftCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHide: false,
        }
    }
    render() {
        return (
            <React.Fragment>
                {this.state.isHide === false && <div className='gift_wrap'>
                    <div className="gift">
                        <div className='gift_content container'>
                            <img className='gift_creative' src={creative} alt="" />
                            <h3 className='gift_h3'>Christmas gift card</h3>
                            <a className='gift_btn' href="https://geekle.us">Claim Offer</a>
                        </div>
                        <svg onClick={() => this.setState({ isHide: true })} className='close_gift' width="30" height="30" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.71313 1.83875L33.0356 33.1612M33.0356 1.83875L1.71313 33.1612" stroke="white" stroke-width="3" />
                        </svg>
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}
